<template>
  <div class="page">
    <main class="layout">
      <!-- LEFT -->
      <section class="left">
        <header class="topbar">
           <img class="topbar__logo" src="../assets/images/logo-perindo-new.png" alt="Partai Perindo" />
         </header>


        <div class="formWrap">
          <h1 class="title">Masuk ke Dashboard</h1>
          <p class="subtitle">Masukkan nomor dan password anda</p>

          <form class="form" @submit.prevent="onSubmit">
            <div class="phoneRow">
              <FieldInput
                v-model="phone"
                label="Nomor Handphone"
                placeholder="Masukkan nomor handphone kamu"
                type="numeric"
                :maxlength="13"
                :state="phoneState"
                :message="phoneMessage"
              />
            </div>

            <FieldInput
              v-model="password"
              label="Password"
              placeholder="Masukkan password"
              :type="showPassword ? 'text' : 'password'"
              :state="passwordState"
              :message="passwordMessage"
            >
              <template #icon>
                <button
                  class="eye"
                  type="button"
                  :aria-label="showPassword ? 'Sembunyikan password' : 'Tampilkan password'"
                  @click="togglePassword"
                >
                  <img src="../assets/images/icon-pass.png" alt="" />
                </button>
              </template>
            </FieldInput>
            <router-link class="forgot-password" to="/forgot-password">Lupa Password?</router-link>

            <button
              class="btn"
              type="submit"
              :disabled="!canSubmit || isLoad"
            >
              {{ isLoad ? "Sedang masuk..." : "Masuk" }}
            </button>

            <vue-programmatic-invisible-google-recaptcha
              ref="invisibleRecaptcha1"
              :sitekey="sitekey"
              :elementId="'invisibleRecaptcha1'"
              :badgePosition="'left'"
              :showBadgeMobile="false"
              :showBadgeDesktop="false"
              @recaptchaCallback="recaptchaCallback"
            />

            <p class="signup">
              Belum punya akun?
              <a href="#" @click.prevent="onDaftar">Daftar Sekarang</a>
            </p>
          </form>

          <div class="info" v-if="banner">
            <div class="info__icon" aria-hidden="true">
              <img :src="banner?.image_url" alt="vision plus" />
            </div>
            <div class="info__text" v-html="banner?.title" />
          </div>
        </div>

        <footer class="footer">
          <span>Copyright 2025 Partai Perindo</span>
        </footer>
      </section>

      <aside class="right">
        <SideCollage />
      </aside>
    </main>
  </div>
  <ActivateAccountModal :show="showActivate" @close="showActivate = false" :phone="phone" />
</template>

<script>
import FieldInput from "@/components/FieldInput.vue";
import axios from "axios";
import SideCollage from '../components/SideCollage.vue'
import ActivateAccountModal from '../components/ActivateAccountModal.vue'
import { bannerCode } from '@/store'

export default {
  name: "LoginPerindo",
  components: { FieldInput, SideCollage, ActivateAccountModal },

  data() {
    return {
      phone: "",
      password: "",
      showPassword: false,

      phoneState: "default",
      phoneMessage: "",
      passwordState: "default",
      passwordMessage: "",

      isLoad: false,

      // opsional (biar tidak undefined)
      recaptha_valid: false,
      banner: null,
      showActivate: false
    };
  },

  computed: {
    canSubmit() {
      return this.phone.trim().length > 0 && this.password.trim().length > 0;
    },
    sitekey() {
      return process.env.VUE_APP_SECRET_KEY;
    },
    loginPayload() {
      return {
        number: this.phone,
        password: this.password,
      };
    },
  },

  watch: {
    phone(val) {
      if (!val) {
        this.phoneState = "default";
        this.phoneMessage = "";
        return;
      }
      if (val.length < 9) {
        this.phoneState = "warning";
        this.phoneMessage = "Nomor terlalu pendek";
      } else {
        this.phoneState = "default";
        this.phoneMessage = "";
      }
    },
    password(val) {
      if (!val) {
        this.passwordState = "default";
        this.passwordMessage = "";
        return;
      }
      if (val.length < 6) {
        this.passwordState = "warning";
        this.passwordMessage = "Password minimal 6 karakter";
      } else {
        this.passwordState = "default";
        this.passwordMessage = "";
      }
    },
  },

  methods: {
    togglePassword() {
      this.showPassword = !this.showPassword;
    },

    showAlert(type, message, options = {}) {
      this.$store.commit("showGlobalAlert", {
        type,
        message,
        duration: options.duration ?? 3000,
        position: options.position ?? "top-center",
      });
    },

    onSubmit() {
      if (!this.canSubmit || this.isLoad) return;

      this.isLoad = true;

      try {
        this.$refs.invisibleRecaptcha1.execute();
      } catch (err) {
        // kalau recaptcha bermasalah, tetap jangan nge-freeze loading
        this.login();
      }
    },

    recaptchaCallback(recaptchaToken) {
      if (recaptchaToken) {
        this.recaptha_valid = true;
        this.login(recaptchaToken);
      } else {
        this.recaptha_valid = false;

        this.passwordState = "error";
        this.passwordMessage = "Recaptcha tidak valid";
        this.showAlert("danger", "Recaptcha tidak valid");

        this.isLoad = false;
      }
    },

    async login(recaptchaToken) {
      try {
        const form = {
          number: this.phone,
          password: this.password,
        };
        if (recaptchaToken) form.recaptchaToken = recaptchaToken;

        const payload = Object.keys(form)
          .map((k) => `${k}=${encodeURIComponent(form[k] ?? "")}`)
          .join("&");

        const res = await axios.post("auth/login", payload, {
          headers: { "Content-Type": "application/x-www-form-urlencoded" },
        });

        if (res?.data?.token) {
          await this.$cookie.setCookie("token", res.data.token);
          await this.$store.commit("setToken", res.data.token);

          const profile = this.$store.getters.getProfile;
          if (profile) {
            await this.$store.commit("setDocumentHighlight", true);
            setTimeout(() => {
              this.$store.commit("setDocumentHighlight", false);
            }, 10000);
          }

          this.$cookie.setCookie("number", res.data.phone_number || this.phone);

          // NOTE: redirect akan happen, tapi kita tetap set loading false biar aman
          this.$router.push("/dashboard");
        } else {
          this.passwordState = "error";
          this.passwordMessage = "Login gagal";
          this.showAlert("danger", "Login gagal");
        }
      } catch (err) {
        if (err?.response) {
          const message = err.response?.data || "Terjadi kesalahan";
          if(message.includes('belum aktif')) {
            this.showActivate = true
            return
          }
          this.showAlert("danger", message);

          this.passwordState = "error";
          this.passwordMessage = message;
        } else {
          this.showAlert("danger", "Tidak bisa terhubung ke server");
          this.passwordState = "error";
          this.passwordMessage = "Tidak bisa terhubung ke server";
        }
      } finally {
        this.isLoad = false;
      }
    },

    onDaftar() {
      this.$router.push({ name: "Daftar" });
    },
  },

  async mounted() {
    const res = await this.$store.dispatch('getBanners', bannerCode.bnrRgstHtml)
    this.banner = res?.data
  }
};
</script>


<style scoped>
.page {
  min-height: 100vh;
  background-color: white;
  overflow: hidden;
}

.layout {
  max-height: 100vh;
  display: flex;
  gap: 24px;
  padding: 18px;
  margin: 0 auto;
}

/* LEFT */
.left {
  overflow-y: auto;
  min-height: calc(100vh - 20px);
  background: #ffffff;
  position: relative;
  padding: 20px 18px;
  display: flex;
  width: 50%;
  align-items: center;
  flex-direction: column;
  justify-content: space-between;
  overflow: auto;
}

.topbar {
  display: flex;
  width: 100%;
  align-items: flex-start;
  justify-content: flex-start;
}

.topbar__logo {
  height: 32px;
  width: auto;
  align-self: flex-start;
  object-fit: contain;
}

.formWrap {
  padding: 56px 0 0;
  max-width: 420px;
  margin: 0 auto;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.title {
  margin: 0;
  font-size: 24px;
  font-weight: 700;
  color: #374151;
}

.subtitle {
  margin: 6px 0 22px;
  color: #6b7280;
  font-size: 14px;
}

.title,
.subtitle {
  text-align: center;
}

/* form layout */
.form {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.phoneRow {
  display: flex;
}

.phonePrefix {
  height: 52px; /* samakan feel tinggi input FieldInput */
  border: 1.5px solid #d0d5dd;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #6b7280;
  font-weight: 700;
  background: #fff;
}

/* Eye button inside FieldInput slot icon */
.eye {
  border: none;
  background: transparent;
  padding: 0;
  display: grid;
  place-items: center;
  width: 34px;
  height: 28px;
  cursor: pointer;
  opacity: 0.75;
}

.eye:hover {
  opacity: 1;
}

.eye img {
  width: 20px;
  height: 20px;
  object-fit: contain;
}

/* Button submit */
.btn {
  margin-top: 6px;
  height: 50px;
  border-radius: 8px;
  border: 1px solid transparent;
  background: #eef2f7;
  color: #9ca3af;
  font-weight: 800;
  cursor: not-allowed;
}

.btn:not(:disabled) {
  background: #223f80;
  color: #ffffff;
  cursor: pointer;
  box-shadow: 0 10px 20px rgba(34, 63, 128, 0.18);
}

.signup {
  margin: 4px 0 0;
  font-size: 13px;
  color: #6b7280;
  text-align: center;
}

.signup a {
  color: #223f80;
  font-weight: 800;
  text-decoration: none;
  margin-left: 4px;
}

.signup a:hover {
  text-decoration: underline;
}

/* info box */
.info {
  margin-top: 18px;
  display: grid;
  grid-template-columns: 40px 1fr;
  gap: 12px;
  align-items: center;
  background: #f8fafc;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  padding: 12px;
}

.info__icon {
  width: 40px;
  height: 40px;
  border-radius: 5px;
  background: #111827;
  display: grid;
  place-items: center;
  overflow: hidden;
}

.info__icon img {
  width: 44px;
  height: 44px;
  object-fit: cover;
}

.info__text {
  margin: 0;
  font-size: 12.5px;
  line-height: 1.35;
  color: #4b5563;
}

.info__text strong {
  color: #374151;
}

.footer {
  padding-top: 48px;
  color: #9ca3af;
  font-size: 12px;
  align-self: flex-start;
}

/* RIGHT */
.right {
  width: 50%;
  display: grid;
  align-items: stretch;
}

.quote {
  margin: 0 0 18px;
  font-size: 15px;
  line-height: 1.45;
  max-width: 520px;
  margin-bottom: 2rem;
}

.author__name {
  font-size: 22px;
  font-weight: 900;
  margin-bottom: 4px;
}

.author__role {
  font-size: 13px;
  opacity: 0.9;
}

/* RESPONSIVE (mobile) */
@media (max-width: 980px) {
  .layout {
    grid-template-columns: 1fr;
    gap: 0;
    padding: 0;
    max-width: 520px;
  }

  .left {
    border-radius: 0;
    border: none;
    width: 100%;
    min-height: 100vh;
    padding: 18px 16px;
  }

  .right {
    display: none;
  }

  .formWrap {
    padding-top: 52px;
    margin-top: 2rem;
  }
}

.forgot-password {
  align-self: flex-end;
  margin-top: -12px;
  font-weight: 600;
  color: #465F97;
}
</style>
